/* eslint-disable @typescript-eslint/no-unused-vars */
import type { ICreateDocResponse } from '@src/slide/domain/slide-app/sync/worker/work/service/request-service/doc-request-service';
import type { INewDocData } from '@src/slide/domain/slide-app/sync/worker/work/create-doc';
import type { IActionProvider } from '@src/slide/domain/slide-app/sync/common/interface/services.interface';
import type { ILogger } from '../../../slide-data-services.core';
import type { ICommitErrorInfo } from '@src/slide/domain/slide-app/sync/worker/work/job/commit-job/service/commit-service';
import type { IUploadResourceTaskOutputData } from '@src/slide/domain/slide-app/sync/worker/work/job/commit-job/task/resource-task/upload-task';

export class ActionService implements IActionProvider {
    protected loggerPrefix = '[ActionService]';

    public constructor(protected logger: ILogger) {}

    /**
     * 处理应用操作的异步方法
     *
     * @param {any} data - 应用操作所需的数据
     * @returns {Promise<boolean>} 返回一个 Promise，表示操作是否成功
     *
     * @description
     * 该方法用于处理应用操作，接收相关数据并返回操作结果。
     * 当前实现始终返回 `true`，表示操作成功。
     */
    public async handleApply(data: any): Promise<boolean> {
        return true;
    }

    /**
     * 处理提交错误的异步方法
     *
     * @param {ICommitErrorInfo} data - 提交错误信息
     * @returns {Promise<void>}
     */
    public async handleCommitError(data: ICommitErrorInfo): Promise<void> {}

    /**
     * 处理新修订的异步方法
     *
     * @param {any} data - 新修订的数据
     * @returns {Promise<void>}
     */
    public async handleNewRevision(data: any): Promise<void> {}

    /**
     * 处理共享工作者连接的异步方法
     *
     * @param {...any} params - 连接参数
     * @returns {Promise<void>}
     */
    public async handleSharedWorkerConnected(...params): Promise<void> {}

    /**
     * 处理客户端变量更新的异步方法
     *
     * @param {any} clientVar - 客户端变量
     * @returns {Promise<void>}
     */
    public async handleUpdateClientVar(clientVar: any): Promise<void> {}

    /**
     * 处理文档被还原的异步方法
     *
     * @returns {Promise<void>}
     */
    public async handleDocIsReverted(): Promise<void> {}

    /**
     * 处理文档不存在的异步方法
     *
     * @returns {Promise<void>}
     */
    public async handleDocIsNotExist(): Promise<void> {}

    /**
     * 处理网络错误的异步方法
     *
     * @param {string} err - 错误信息
     * @returns {Promise<void>}
     */
    public async handleNetworkError(err: string): Promise<void> {}

    /**
     * 处理转换错误的异步方法
     *
     * @param {string} err - 错误信息
     * @returns {Promise<void>}
     */
    public async handleTransformedError(err: string): Promise<void> {}

    /**
     * 处理创建成功的异步方法
     *
     * @param {INewDocData} data - 新文档数据
     * @returns {Promise<void>}
     */
    public async handleCreateSuccess(data: INewDocData): Promise<void> {}

    /**
     * 处理创建错误的异步方法
     *
     * @param {Partial<ICreateDocResponse>} data - 创建响应的部分数据
     * @returns {Promise<void>}
     */
    public async handleCreateError(data: Partial<ICreateDocResponse>): Promise<void> {}

    /**
     * 处理提交前的异步方法
     *
     * @param {number} commitLength - 提交长度
     * @returns {Promise<void>}
     */
    public async handleBeforeCommit(commitLength: number): Promise<void> {}

    /**
     * 处理提交成功的异步方法
     *
     * @param {number} preCommitLength - 提交前的长度
     * @param {number} commitLength - 提交长度
     * @returns {Promise<void>}
     */
    public async handleCommitSuccess(preCommitLength: number, commitLength: number): Promise<void> {}

    /**
     * 处理上传错误的异步方法
     *
     * @param {IUploadResourceTaskOutputData} data - 上传资源任务输出数据
     * @returns {Promise<void>}
     */
    public async handleUploadError(data: IUploadResourceTaskOutputData): Promise<void> {}

    /**
     * 处理提交完成的异步方法
     *
     * @returns {Promise<void>}
     */
    public async handleCommitComplete(): Promise<void> {}

    /**
     * 处理合并冲突错误的异步方法
     *
     * @param {string} msg - 错误信息
     * @returns {Promise<void>}
     */
    public async handleMergeConflictError(msg: string): Promise<void> {}
}
